// Vendor / polyfills
import 'babel-polyfill'
import 'custom-event-polyfill'
import 'objectFitPolyfill'

import Start from './app'

// services
import './services/Browser'
import './services/Scroll'
import initShopify from './services/Shopify'

// components
import './components/Menu'
import './components/ToggleMenuButton'
import './components/Body'
import './components/MenuShopButton'
import './components/Carousel'
import './components/InnerWindowHeight'
import './components/LoadImage'
import './components/ProductPreview'
import './components/ProductATC'
import './components/ScrollBarPad'
import './components/Header'
import './components/Cart'
import './components/CartCount'
import './components/ToggleCartButton'
import './components/ShowOnCart'
import './components/CheckoutButton'
import './components/SideCart'
import './components/VariantBackground'
import './components/VariantTextColor'
import './components/VariantPrimaryBackground'
import './components/VariantPrimaryBorder'
import './components/VariantPrimary'
import './components/PdpCarousel'
import './components/Tabs'
import './components/ATCButton'
import './components/ProductList'
import './components/SSCategory'
import './components/SSCarousel'
import './components/SSDeselect'
import './components/SSSelected'
import './components/SectionNav'
import './components/ImageZoom'
import './components/PolicyNav'
import './components/QuickBuyOverlay'
import './components/WatchImageLoad'
import './components/AnimateEntry'
import './components/AfterpayOverlay'
import './components/AfterpayToggle'

document.addEventListener('DOMContentLoaded', () => {
    const appEl = document.querySelector('[data-app]')
    if (appEl) Start(appEl)
    initShopify()
})